//#region Libraries
import { useState } from "react";
//#endregion
//#region Styles
import { Part, TitleSection, Column, Row } from "components/styles";
//#endregion
//#region Components
import SearchInDialogAlert from "components/SearchInDialogAlert/SearchInDialogAlert";
import CustomSelect from "components/CustomSelect/CustomSelect";
//#endregion
//#region Services
import { requestGetTeachers } from "services/general";
//#endregion

const Part2 = ({
	loadingRequest,
	data: { payGradeList },
	form,
	changeField,
	errors,
	errorTexts,
}) => {
	const { tutor, payGradeId } = form;
	//#region States
	const [showDialogSearchTutor, setShowDialogSearchTutor] = useState(false);
	const [timeoutIdToSearch, setTimeoutIdToSearch] = useState(null);
	const [matchedTutorList, setMatchedTutorList] = useState([]);
	const [mostSimilarTutor, setMostSimilarTutor] = useState("");
	//#endregion
	//#region Effects
	//#endregion
	//#region Functions
	const toggleDialogSearchTutor = (value = null) => {
		setShowDialogSearchTutor(
			value !== null ? value : !showDialogSearchTutor
		);
	};
	const changeTutorField = ({ id, text }) => {
		changeField(
			"tutor",
			{
				id,
				fullName: text,
			},
			false
		);
	};
	const changePayGradeField = value => {
		changeField("payGradeId", value, false);
	};
	const fillMatchedTutorList = async nameTutor => {
		// Borrando id del callback timeout si es que se teclea antes de la ejecución de la función
		clearTimeout(timeoutIdToSearch);
		// Programando ejecución de la búsqueda a 500ms
		const timeoutId = setTimeout(async () => {
			// Obteniendo referencia del elemento en focus
			const $input = document.activeElement;
			// Definiendo función de manejo del loader
			const nameTutorTrim = nameTutor.trim();
			const handlerLoading = (activateLoader = false) => {
				if (!nameTutorTrim) return;
				$input[activateLoader ? "blur" : "focus"]();
				if (!activateLoader) {
					loadingRequest.hide();
					return;
				}
				loadingRequest.show("Buscando tutor...");
			};
			handlerLoading(true);
			// Obteniendo lista de docentes
			const tutorList = !nameTutorTrim
				? []
				: await getTeachers(nameTutorTrim);
			handlerLoading();
			// Llenando de lista de docentes
			setMatchedTutorList(tutorList);
			// Verificando si no fue encontrado para buscar los similares
			if (nameTutorTrim && tutorList.length === 0) {
				handlerLoading(true);
				const tutorListMostSimilar = await getTeachers(
					nameTutorTrim[0],
					true
				);
				handlerLoading();
				const newMostSimilar = tutorListMostSimilar.find(({ text }) => {
					return (
						text[0].toUpperCase() === nameTutorTrim[0].toUpperCase()
					);
				});
				setMostSimilarTutor(newMostSimilar?.text || "");
			}
		}, 500);
		setTimeoutIdToSearch(timeoutId);
	};
	const clearMatchedTutorList = () => setMatchedTutorList([]);
	const getTeachers = async (nameTutor, similar) => {
		const data = await requestGetTeachers(nameTutor, "Refuerzo", similar);
		const fetchTutors = data.map(({ codigoDocente, nombreDocente }) => {
			return {
				id: codigoDocente,
				text: nombreDocente,
			};
		});
		return fetchTutors;
	};
	//#endregion
	const tutorText = tutor.id && `${tutor.fullName} (${tutor.id})`;
	return (
		<Part>
			<Column marginBottom="14px">
				<TitleSection>Organización</TitleSection>
			</Column>
			<Row>
				<SearchInDialogAlert
					inputButtonTextProps={{
						placeholder: "Buscar un tutor",
						helperText:
							"Para seleccionar un tutor(a), primero tienes que seleccionar un curso",
						text: tutorText,
						error: errors.tutor,
						errorText: errorTexts.tutorSearch,
					}}
					placeholder="Escribe el nombre y apellido"
					label="Tutor(a) a cargo:"
					changeSearchField={changeTutorField}
					data={matchedTutorList}
					fillData={fillMatchedTutorList}
					clearData={clearMatchedTutorList}
					mostSimilar={mostSimilarTutor}
					firstSelection={tutor.id}
					getDataItemText={({ id, text }) => `${text} (${id})`}
					name={tutorText}
					titleDialog="Busca al tutor(a)"
					loadingSearch={!loadingRequest.value.hidden}
					showDialogAlert={showDialogSearchTutor}
					toggleDialogAlert={toggleDialogSearchTutor}
					notFoundMessage="El nombre que estás buscando no está en la lista de docentes."
					notFoundSubmessage="*Si el nombre no está en la lista, puedes escribirlo manualmente."
				/>
				<CustomSelect
					label="Categoría salarial"
					value={payGradeId}
					onChange={changePayGradeField}
					defaultOptionText="Selecciona una categoría"
					optionsProps={payGradeList.map(({ id }) => ({
						value: id,
						text: id,
					}))}
					error={errors.payGradeId}
					errorText="Es necesario seleccionar una categoría salarial"
				/>
			</Row>
		</Part>
	);
};

export default Part2;
